export const messages = {
  en: {
    resourceStoreUseRecordManage: {
      search: {
        title: 'Search Conditions',
        rsurId: 'Please enter use record ID',
        repairId: 'Please enter repair order code',
        resId: 'Please enter resource ID',
        createUserId: 'Please enter user ID',
        createUserName: 'Please enter username',
        resName: 'Please enter resource name',
        parentRstId: 'Please select resource type',
        rstId: 'Please select secondary category',
        rssId: 'Please select resource specification',
        state: 'Please select usage type',
        startTime: 'Please select start time',
        endTime: 'Please select end time'
      },
      list: {
        title: 'Usage Records'
      },
      table: {
        rsurId: 'Usage Record ID',
        repairId: 'Repair Order Code',
        resId: 'Resource ID',
        resourceType: 'Resource Type',
        resourceStoreName: 'Resource Name',
        specName: 'Specification',
        isFixedName: 'Fixed Resource',
        stateName: 'Usage Type',
        quantity: 'Quantity',
        unitPrice: 'Price',
        createUserId: 'User ID',
        createUserName: 'User',
        createTime: 'Create Time',
        remark: 'Remark'
      }
    }
  },
  zh: {
    resourceStoreUseRecordManage: {
      search: {
        title: '查询条件',
        rsurId: '请输入使用记录ID',
        repairId: '请输入维修工单编码',
        resId: '请输入物品资源编号',
        createUserId: '请输入物品使用人ID',
        createUserName: '请输入用户名',
        resName: '请输入物品名称',
        parentRstId: '请选择物品类型',
        rstId: '请选择二级分类',
        rssId: '请选择物品规格',
        state: '请选择物品使用类型',
        startTime: '请选择开始时间',
        endTime: '请选择结束时间'
      },
      list: {
        title: '使用记录'
      },
      table: {
        rsurId: '使用记录ID',
        repairId: '维修工单编号',
        resId: '物品编号',
        resourceType: '物品类型',
        resourceStoreName: '物品名称',
        specName: '物品规格',
        isFixedName: '固定物品',
        stateName: '使用类型',
        quantity: '使用数量',
        unitPrice: '物品价格',
        createUserId: '使用人ID',
        createUserName: '使用人',
        createTime: '创建时间',
        remark: '备注'
      }
    }
  }
}